document.querySelectorAll<HTMLTextAreaElement>('.char-countdown').forEach(el => {
    const counter = el.nextElementSibling as HTMLElement;
    const threshold = 400;

    function update() {
        const remaining = el.maxLength - el.value.length;
        const visible = remaining <= threshold;
        counter.style.display = visible ? '' : 'none';
        counter.textContent = remaining + ' characters remaining';
        counter.classList.toggle('text-danger', remaining < 100);
        counter.classList.toggle('text-muted', remaining >= 100);
    }

    el.addEventListener('input', update);
    update();
});
